import type { Seminar } from 'services/seminars/types'

import Button from 'content-components/_Primatives/Button'
import style from './style.scss'

type Props = {
  className?: string
  seminar: Seminar
  soldOutButtonText: string
  registerButtonText: string
}

function ButtonTableCell({
  className,
  seminar,
  soldOutButtonText,
  registerButtonText,
}: Props) {
  const url = seminar.isWaitListed ? '' : seminar.url
  const variant = seminar.isWaitListed ? 'primaryYellow' : 'primaryGreen'
  const text = seminar.isWaitListed ? soldOutButtonText : registerButtonText

  return (
    <td className={className}>
      <Button url={url} variant={variant} className={style.button}>
        {text}
      </Button>
    </td>
  )
}

export default ButtonTableCell
